import { Col, Container, Form, Table } from "react-bootstrap";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../modules/helper";
import Card from "../../components/ui/div/Card";
import LoadingButton from "../../components/loading/LoadingButton";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import moment from "jalali-moment";
import { useSearchParams } from "react-router-dom";
import PaginateCard from "../../components/PaginateCard";
import Laoder from "../../components/loading/Loader";
import jalaliTime from "../../functions/jalaliTime";
import { useState } from "react";
import ModalTicketAnswer from "./components/ModalTicketAnswer";
import PrintLink from "../../components/shipment/Factor/PrintLink";

function Tickets() {
  const {
    isFetching: isLoading,
    data,
    refetch,
  } = useQuery({
    queryKey: ["supervisorTickets"],
    queryFn: () =>
      getAuthMethod(
        "/supervisor/v1/tickets",
        Object.fromEntries([...searchParams])
      ).then(res => res.data.result),
    refetchOnWindowFocus: false,
  });

  const [ticketAnswer, setTicketAnswer] = useState({});

  const [searchParams, setSearchParams] = useSearchParams({
    items: 10,
    page: 1,
  });

  const set = ({ label, value }) => {
    setSearchParams(cur => {
      if (!value || value === "0") {
        delete cur.delete(label);
      } else {
        cur.set(label, value);
      }
      return cur;
    });
  };

  const getTime = ({ e, jTm = true, name = "" }) => {
    if (jTm) {
      if (e)
        return moment(
          e.year + "/" + e.month.number + "/" + e?.day,
          "jYYYY/jM/jD"
        ).format("YYYY-MM-DD");
      else return undefined;
    }

    const time = searchParams.get(name);

    return time
      ? moment(time, "YYYY-MM-DD").format("jYYYY/jMM/jDD")
      : undefined;
  };

  return (
    <MainMenu>
      <Container>
        <h5>لیست تیکت ها</h5>

        <form
          onSubmit={e => {
            e.preventDefault();
            set({ label: "page", value: 1 });
            refetch();
          }}
        >
          <Card className="d-flex flex-wrap column-gap-3 row-gap-2 mt-4">
            <Col xs="12" sm="5" lg="3" xxl="2">
              <Form.Label>تعداد نمایش</Form.Label>
              <Form.Select
                defaultValue={searchParams.get("items")}
                onChange={e => set({ label: "items", value: e.target.value })}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Select>
            </Col>
            <Col xs="12" sm="5" lg="3" xxl="2">
              <Form.Label>شماره سفارش:</Form.Label>
              <Form.Control
                type="number"
                defaultValue={searchParams.get("barname")}
                onChange={e => set({ label: "barname", value: e.target.value })}
              />
            </Col>

            <Col xs="12" sm="5" lg="3" xxl="2">
              <Form.Label>وضعیت</Form.Label>
              <Form.Select
                defaultValue={searchParams.get("status")}
                onChange={e => set({ label: "status", value: e.target.value })}
              >
                <option value={0}>همه</option>
                <option value={1}>پاسخ داده نشده</option>
                <option value={2}>پاسخ داده شده</option>
              </Form.Select>
            </Col>

            <div className="w-100 d-flex flex-wrap gap-2">
              <Col xs="12" sm="5" lg="3" xxl="2">
                <Form.Label>از تاریخ</Form.Label>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  value={getTime({ jTm: false, name: "startDate" })}
                  style={{ width: "100%", height: "2.2rem" }}
                  onChange={e =>
                    set({
                      label: "startDate",
                      value: getTime({ e }),
                    })
                  }
                />
              </Col>

              <Col xs="12" sm="5" lg="3" xxl="2">
                <Form.Label>تا تاریخ</Form.Label>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  value={getTime({ jTm: false, name: "endDate" })}
                  style={{ width: "100%", height: "2.2rem" }}
                  onChange={e =>
                    set({
                      label: "endDate",
                      value: getTime({ e }),
                    })
                  }
                />
              </Col>

              <Col
                xs="12"
                sm="5"
                lg="3"
                xxl="2"
                className="me-auto d-flex align-items-end justify-content-end"
              >
                {isLoading === true && (
                  <LoadingButton
                    className="btn-primary"
                    title="در حال دریافت"
                  />
                )}
                {isLoading === false && (
                  <button className="btn btn-primary" type="submit">
                    فیلتر
                  </button>
                )}
              </Col>
            </div>
          </Card>
        </form>

        <section className="w-100 px-1 overflow-x-auto mt-4">
          <Table className="text-center" bordered={true} striped={true}>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شماره تیکت</th>
                <th>شماره سفارش</th>
                <th>موضوع</th>
                <th>نام</th>
                <th>پیام</th>
                <th>وضعیت</th>
                <th>تاریخ</th>
                <th>پاسخ</th>
                <th>عملیات</th>
              </tr>
            </thead>

            <tbody>
              {isLoading && (
                <tr>
                  <td colSpan={10}>
                    <Laoder />
                  </td>
                </tr>
              )}
              {isLoading === false &&
                data?.tickets?.map((item, idx) => (
                  <tr key={item.id}>
                    <td>
                      {idx +
                        1 +
                        (searchParams.get("page") - 1) *
                          searchParams.get("items")}
                    </td>
                    <td>{item.id}</td>
                    <td>
                      <PrintLink ids={[item.numberParcel]} byNumberParcel>
                        {item.numberParcel}
                      </PrintLink>
                    </td>
                    <td>{item.subject}</td>
                    <td>
                      <span>{item.user.name}</span>
                      <span> {item.user.family}</span>
                    </td>
                    <td>{item.message}</td>
                    <td>{item.status}</td>
                    <td>{jalaliTime(item.created_at).full}</td>
                    <td>{item.answer}</td>
                    <td>
                      <button
                        className="buttonUi text-success"
                        onClick={() => setTicketAnswer(item)}
                      >
                        پاسخ
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </section>

        <section className="mt-4">
          <PaginateCard
            count={data?.count}
            numberItems={parseInt(searchParams.get("items"))}
            numberPage={parseInt(searchParams.get("page"))}
            onIndexChoose={number => set({ label: "page", value: number })}
          />
        </section>

        {ticketAnswer.id !== undefined && (
          <ModalTicketAnswer
            close={() => setTicketAnswer({})}
            ticket={ticketAnswer}
            refetch={refetch}
          />
        )}
      </Container>
    </MainMenu>
  );
}

export default Tickets;
